import { BreachEvent, click_origin_breach_screen } from '@news-mono/web-common'
import React from 'react'
import { AuthenticationProvider } from '../../../../../../user-registration/authentication/AuthenticationProvider'
import { createLinkClickEvent } from '../../../../createLinkClickHandler'
import SubscriptionPackage, {
    SubscriptionPackageProps,
} from '../../../SubscriptionPackage/SubscriptionPackage'
import {
    StyledBreachWallContent,
    StyledButton,
    StyledPackage,
    StyledRegistrationInfo,
} from './BreachWallContent.styled'

export interface BreachWallContentProps {
    title: () => JSX.Element | null
    terms: () => JSX.Element | null
    mediaBanner: () => JSX.Element | null
    subscriptionPackages?: SubscriptionPackageProps[]

    breachCreativeName: string
    breachDeal: string
    onEvent: (event: BreachEvent) => void
}

export const BreachWallContent: React.FC<BreachWallContentProps> = ({
    title,
    subscriptionPackages,
    breachCreativeName,
    breachDeal,
    onEvent,
    mediaBanner,
    terms,
}) => {
    const renderMediaBanner = mediaBanner
    const renderTitleSection = title
    const renderTerms = terms

    return (
        <AuthenticationProvider onEvent={onEvent}>
            {({ onSubscribeClick }) => (
                <StyledBreachWallContent>
                    {renderMediaBanner()}
                    <StyledRegistrationInfo>
                        {renderTitleSection()}

                        <StyledButton
                            onClick={() => {
                                createLinkClickEvent(
                                    breachCreativeName,
                                    breachDeal,
                                    onEvent,
                                )()
                                onSubscribeClick({
                                    callToAction: click_origin_breach_screen,
                                })
                            }}
                        >
                            View All Packages
                        </StyledButton>
                        {renderTerms()}
                    </StyledRegistrationInfo>
                    <StyledPackage>
                        {subscriptionPackages &&
                            subscriptionPackages.map(
                                (subscriptionPackageItem, index) => {
                                    return (
                                        <SubscriptionPackage
                                            key={index}
                                            breachCreativeName={
                                                breachCreativeName
                                            }
                                            breachDeal={breachDeal}
                                            onEvent={
                                                subscriptionPackageItem.onEvent
                                            }
                                            ribbonTitle={
                                                subscriptionPackageItem.ribbonTitle
                                            }
                                            pretitle={
                                                subscriptionPackageItem.pretitle
                                            }
                                            heading={
                                                subscriptionPackageItem.heading
                                            }
                                            price={
                                                subscriptionPackageItem.price
                                            }
                                            originalPrice={
                                                subscriptionPackageItem.originalPrice
                                            }
                                            priceQualifier={
                                                subscriptionPackageItem.priceQualifier
                                            }
                                            offerCode={
                                                subscriptionPackageItem.offerCode
                                            }
                                            packageTheme={
                                                subscriptionPackageItem.packageTheme
                                            }
                                            packagePath={
                                                subscriptionPackageItem.packagePath
                                            }
                                            packageType={
                                                subscriptionPackageItem.packageType
                                            }
                                        />
                                    )
                                },
                            )}
                    </StyledPackage>
                </StyledBreachWallContent>
            )}
        </AuthenticationProvider>
    )
}
BreachWallContent.displayName = 'BreachWallContent'

export default BreachWallContent
